import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "p-2 days mr-2 relative"
}
const _hoisted_3 = { class: "p-2 hours mx-2 relative" }
const _hoisted_4 = { class: "p-2 minutes mx-2 relative" }
const _hoisted_5 = { class: "p-2 seconds ml-2 relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.expired)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              class: _normalizeClass(["d-flex align-items-center justify-content-center", _ctx.className])
            }, [
              (_ctx.displayDays>0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.classText)
                    }, _toDisplayString(_ctx.displayDays), 3),
                    _createElementVNode("div", {
                      class: "text-sm absolute bottom-0",
                      style: _normalizeStyle(_ctx.subtitle)
                    }, _toDisplayString(_ctx.t("days")), 5)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.displayDays>0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(["leading-snug", _ctx.classText])
                  }, ":", 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.classText)
                }, _toDisplayString(_ctx.displayHours), 3),
                _createElementVNode("div", {
                  class: "text-sm absolute bottom-0",
                  style: _normalizeStyle(_ctx.subtitle)
                }, _toDisplayString(_ctx.t("hours")), 5)
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["leading-snug", _ctx.classText])
              }, ":", 2),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.classText)
                }, _toDisplayString(_ctx.displayMinutes), 3),
                _createElementVNode("div", {
                  class: "text-sm absolute bottom-0",
                  style: _normalizeStyle(_ctx.subtitle)
                }, _toDisplayString(_ctx.t("minutes")), 5)
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["leading-snug", _ctx.classText])
              }, ":", 2),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.classText)
                }, _toDisplayString(_ctx.displaySeconds), 3),
                _createElementVNode("div", {
                  class: "text-sm absolute bottom-0",
                  style: _normalizeStyle(_ctx.subtitle)
                }, _toDisplayString(_ctx.t("seconds")), 5)
              ])
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.expired)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["alert text-center fade show alert-danger", _ctx.dangerClass])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.dangerText)
              }, _toDisplayString(_ctx.t('acrd11')), 3)
            ], 2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}